import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const VerstetigungAbschlussStartUp: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Durchführung des Vorhabens" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default VerstetigungAbschlussStartUp;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0163298819_ssischen_Startup_Oekosystems,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0191581550_d_Finanzierung_Von_Angeboten,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
export const getFormStrucVerstetigungAbschlussStartUp = () => {
	return concat(formStruc());
};
